import { render } from "./CalculatorBlock.vue?vue&type=template&id=32d5eb66&scoped=true"
import script from "./CalculatorBlock.vue?vue&type=script&lang=js"
export * from "./CalculatorBlock.vue?vue&type=script&lang=js"

import "./CalculatorBlock.vue?vue&type=style&index=0&id=32d5eb66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d5eb66"]])

export default __exports__